import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';

interface saveParams {
  btNumber: string,
  data: any
}
export async function massUpdateLocationHOO({ btNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-hours`, baseURL };
  const response = await maestroApiCall(apiType, data).then((res) => res.data);
  return response;
}
